/**
 * apportionApplication模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const apportionApplication = {
  //应用名
  selectApportionApplication(params) {
    return $http.post(`${global.API_URL}/sme/apportionApplication/selectApportionApplication`,params);
  },
}

export default apportionApplication;



// WEBPACK FOOTER //
// ./src/api/apportionApplication.js